module.exports = __webpack_public_path__ + "img/M.ae75807f.png";